var WCPS_1_0_Module_Factory = function () {
  var WCPS_1_0 = {
    n: 'WCPS_1_0',
    dens: 'http:\/\/www.opengis.net\/wcps\/1.0',
    deps: ['GML_3_1_1', 'WCS_1_1'],
    tis: [{
        ln: 'ScalarExprType',
        ps: [{
            n: 'identifier',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'imageCrs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'imageCrsDomain',
            rq: true,
            ti: '.CondenseScalarExprType.ImageCrsDomain'
          }, {
            n: 'crsSet',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'domainMetadata',
            rq: true,
            en: 'DomainMetadata',
            ti: '.DomainMetadataExprType'
          }, {
            n: 'nullSet',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'interpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationDefault'
          }, {
            n: 'interpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet'
          }, {
            n: 'booleanConstant',
            rq: true,
            ti: 'Boolean'
          }, {
            n: 'booleanNot',
            rq: true,
            ti: '.BooleanScalarExprType'
          }, {
            n: 'booleanAnd',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanOr',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanXor',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanLessThan',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanLessOrEqual',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanGreaterThan',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanGreaterOrEqual',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanEqualNumeric',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanNotEqualNumeric',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanEqualString',
            rq: true,
            ti: '.StringScalarExprPairType'
          }, {
            n: 'booleanNotEqualString',
            rq: true,
            ti: '.StringScalarExprPairType'
          }, {
            n: 'numericConstant',
            rq: true,
            ti: 'Double'
          }, {
            n: 'complexConstant',
            rq: true,
            ti: '.ComplexConstantType'
          }, {
            n: 'numericUnaryMinus',
            rq: true,
            ti: '.CondenseScalarExprType.NumericUnaryMinus'
          }, {
            n: 'numericAdd',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'numericMinus',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'numericMult',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'numericDiv',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'condense',
            rq: true,
            ti: '.CondenseScalarExprType'
          }, {
            n: 'reduce',
            rq: true,
            ti: '.ReduceScalarExprType'
          }, {
            n: 'all',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'some',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'count',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'add',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'avg',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'min',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'max',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'stringIdentifier',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'stringConstant',
            rq: true
          }]
      }, {
        ln: 'CondenseScalarExprType.InterpolationSet.SetInterpolationSet',
        tn: null,
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'field',
            rq: true,
            ti: '.FieldNameType'
          }, {
            n: 'interpolationMethodType',
            mno: 0,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'interpolationMethod'
              }, {
                en: 'nullResistance'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'CrsTransformCoverageExprType',
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'dimensionIntervalElementType',
            rq: true,
            mno: 3,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'arctan',
                ti: '.CoverageExprElementType'
              }, {
                en: 'setInterpolationSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
              }, {
                en: 'equals',
                ti: '.CoverageExprPairType'
              }, {
                en: 'construct',
                ti: '.ConstructCoverageExprType'
              }, {
                en: 'cos',
                ti: '.CoverageExprElementType'
              }, {
                en: 'slice',
                ti: '.SliceCoverageExprType'
              }, {
                en: 'setInterpolationDefault',
                ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
              }, {
                en: 'arccos',
                ti: '.CoverageExprElementType'
              }, {
                en: 'sin',
                ti: '.CoverageExprElementType'
              }, {
                en: 'unaryMinus',
                ti: '.CoverageExprElementType'
              }, {
                en: 'im',
                ti: '.CoverageExprElementType'
              }, {
                en: 'tanh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'greaterThan',
                ti: '.CoverageExprPairType'
              }, {
                en: 'scale',
                ti: '.ScaleCoverageExprType'
              }, {
                en: 'cosh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'const',
                ti: '.ConstantCoverageExprType'
              }, {
                en: 'arcsin',
                ti: '.CoverageExprElementType'
              }, {
                en: 'div',
                ti: '.CoverageExprPairType'
              }, {
                en: 'coverage'
              }, {
                en: 'plus',
                ti: '.CoverageExprPairType'
              }, {
                en: 'greaterOrEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'lessThan',
                ti: '.CoverageExprPairType'
              }, {
                en: 'tan',
                ti: '.CoverageExprElementType'
              }, {
                en: 'not',
                ti: '.CoverageExprElementType'
              }, {
                en: 'fieldSelect',
                ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
              }, {
                en: 'setNullSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
              }, {
                en: 'extend',
                ti: '.ExtendCoverageExprType'
              }, {
                en: 'sinh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'and',
                ti: '.CoverageExprPairType'
              }, {
                en: 'abs',
                ti: '.CoverageExprElementType'
              }, {
                en: 'mult',
                ti: '.CoverageExprPairType'
              }, {
                en: 'trim',
                ti: '.TrimCoverageExprType'
              }, {
                en: 'setCrsSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
              }, {
                en: 'lowerBound',
                ti: '.ScalarExprType'
              }, {
                en: 'rangeConstructor',
                ti: '.RangeCoverageExprType'
              }, {
                en: 'upperBound',
                ti: '.ScalarExprType'
              }, {
                en: 'xor',
                ti: '.CoverageExprPairType'
              }, {
                en: 'or',
                ti: '.CoverageExprPairType'
              }, {
                en: 'exp',
                ti: '.CoverageExprElementType'
              }, {
                en: 'minus',
                ti: '.CoverageExprPairType'
              }, {
                en: 'lessOrEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'setIdentifier',
                ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
              }, {
                en: 'crsTransform',
                ti: '.CrsTransformCoverageExprType'
              }, {
                en: 're',
                ti: '.CoverageExprElementType'
              }, {
                en: {
                  lp: 'srsName',
                  ns: 'http:\/\/www.opengis.net\/gml'
                },
                ti: 'GML_3_1_1.CodeType'
              }, {
                en: 'axis'
              }, {
                en: 'unaryPlus',
                ti: '.CoverageExprElementType'
              }, {
                en: 'cast',
                ti: '.CondenseScalarExprType.InterpolationSet.Cast'
              }, {
                en: 'bit',
                ti: '.CondenseScalarExprType.InterpolationSet.Bit'
              }, {
                en: 'ln',
                ti: '.CoverageExprElementType'
              }, {
                en: 'log',
                ti: '.CoverageExprElementType'
              }, {
                en: 'overlay',
                ti: '.CoverageExprPairType'
              }, {
                en: 'sqrt',
                ti: '.CoverageExprElementType'
              }, {
                en: 'notEqual',
                ti: '.CoverageExprPairType'
              }],
            t: 'ers'
          }, {
            n: 'fieldInterpolationElementType',
            rq: true,
            mno: 3,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'interpolationMethod'
              }, {
                en: 'name'
              }, {
                en: 'nullResistance'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'RangeCoverageExprType',
        ps: [{
            n: 'component',
            rq: true,
            col: true,
            ti: '.RangeCoverageExprType.Component'
          }]
      }, {
        ln: 'ReduceScalarExprType',
        ps: [{
            n: 'all',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'some',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'count',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'add',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'avg',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'min',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'max',
            rq: true,
            ti: '.CoverageExprElementType'
          }]
      }, {
        ln: 'SliceCoverageExprType',
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'dimensionPointElementType',
            rq: true,
            mno: 2,
            col: true,
            etis: [{
                en: 'axis'
              }, {
                en: {
                  lp: 'srsName',
                  ns: 'http:\/\/www.opengis.net\/gml'
                },
                ti: 'GML_3_1_1.CodeType'
              }, {
                en: 'slicingPosition',
                ti: '.ScalarExprType'
              }],
            t: 'es'
          }]
      }, {
        ln: 'CondenseScalarExprType.InterpolationSet.Cast',
        tn: null,
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'type',
            rq: true
          }]
      }, {
        ln: 'CoverageExprPairType',
        ps: [{
            n: 'content',
            rq: true,
            mno: 2,
            mxo: 2,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'booleanLessThan',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'booleanLessOrEqual',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'booleanOr',
                ti: '.BooleanScalarExprPairType'
              }, {
                en: 'booleanGreaterThan',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'booleanXor',
                ti: '.BooleanScalarExprPairType'
              }, {
                en: 'arccos',
                ti: '.CoverageExprElementType'
              }, {
                en: 'notEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'stringConstant'
              }, {
                en: 'mult',
                ti: '.CoverageExprPairType'
              }, {
                en: 'all',
                ti: '.CoverageExprElementType'
              }, {
                en: 'abs',
                ti: '.CoverageExprElementType'
              }, {
                en: 'count',
                ti: '.CoverageExprElementType'
              }, {
                en: 'numericConstant',
                ti: 'Double'
              }, {
                en: 'const',
                ti: '.ConstantCoverageExprType'
              }, {
                en: 're',
                ti: '.CoverageExprElementType'
              }, {
                en: 'unaryPlus',
                ti: '.CoverageExprElementType'
              }, {
                en: 'booleanNot',
                ti: '.BooleanScalarExprType'
              }, {
                en: 'max',
                ti: '.CoverageExprElementType'
              }, {
                en: 'sinh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'xor',
                ti: '.CoverageExprPairType'
              }, {
                en: 'numericMult',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'setInterpolationSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
              }, {
                en: 'coverage'
              }, {
                en: 'im',
                ti: '.CoverageExprElementType'
              }, {
                en: 'minus',
                ti: '.CoverageExprPairType'
              }, {
                en: 'cosh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'crsSet',
                ti: '.CoverageExprElementType'
              }, {
                en: 'greaterOrEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'stringIdentifier',
                ti: '.CoverageExprElementType'
              }, {
                en: 'condense',
                ti: '.CondenseScalarExprType'
              }, {
                en: 'booleanAnd',
                ti: '.BooleanScalarExprPairType'
              }, {
                en: 'tanh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'fieldSelect',
                ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
              }, {
                en: 'scale',
                ti: '.ScaleCoverageExprType'
              }, {
                en: 'nullSet',
                ti: '.CoverageExprElementType'
              }, {
                en: 'equals',
                ti: '.CoverageExprPairType'
              }, {
                en: 'booleanConstant',
                ti: 'Boolean'
              }, {
                en: 'trim',
                ti: '.TrimCoverageExprType'
              }, {
                en: 'sin',
                ti: '.CoverageExprElementType'
              }, {
                en: 'numericAdd',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'numericMinus',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'avg',
                ti: '.CoverageExprElementType'
              }, {
                en: 'booleanNotEqualString',
                ti: '.StringScalarExprPairType'
              }, {
                en: 'reduce',
                ti: '.ReduceScalarExprType'
              }, {
                en: 'min',
                ti: '.CoverageExprElementType'
              }, {
                en: 'numericUnaryMinus',
                ti: '.CondenseScalarExprType.NumericUnaryMinus'
              }, {
                en: 'cos',
                ti: '.CoverageExprElementType'
              }, {
                en: 'rangeConstructor',
                ti: '.RangeCoverageExprType'
              }, {
                en: 'plus',
                ti: '.CoverageExprPairType'
              }, {
                en: 'arcsin',
                ti: '.CoverageExprElementType'
              }, {
                en: 'imageCrs',
                ti: '.CoverageExprElementType'
              }, {
                en: 'booleanGreaterOrEqual',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'slice',
                ti: '.SliceCoverageExprType'
              }, {
                en: 'greaterThan',
                ti: '.CoverageExprPairType'
              }, {
                en: 'exp',
                ti: '.CoverageExprElementType'
              }, {
                en: 'cast',
                ti: '.CondenseScalarExprType.InterpolationSet.Cast'
              }, {
                en: 'and',
                ti: '.CoverageExprPairType'
              }, {
                en: 'complexConstant',
                ti: '.ComplexConstantType'
              }, {
                en: 'div',
                ti: '.CoverageExprPairType'
              }, {
                en: 'booleanNotEqualNumeric',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'setIdentifier',
                ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
              }, {
                en: 'lessOrEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'numericDiv',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'booleanEqualString',
                ti: '.StringScalarExprPairType'
              }, {
                en: 'log',
                ti: '.CoverageExprElementType'
              }, {
                en: 'ln',
                ti: '.CoverageExprElementType'
              }, {
                en: 'or',
                ti: '.CoverageExprPairType'
              }, {
                en: 'setNullSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
              }, {
                en: 'arctan',
                ti: '.CoverageExprElementType'
              }, {
                en: 'imageCrsDomain',
                ti: '.CondenseScalarExprType.ImageCrsDomain'
              }, {
                en: 'lessThan',
                ti: '.CoverageExprPairType'
              }, {
                en: 'booleanEqualNumeric',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'tan',
                ti: '.CoverageExprElementType'
              }, {
                en: 'setInterpolationDefault',
                ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
              }, {
                en: 'setCrsSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
              }, {
                en: 'extend',
                ti: '.ExtendCoverageExprType'
              }, {
                en: 'interpolationSet',
                ti: '.CondenseScalarExprType.InterpolationSet'
              }, {
                en: 'interpolationDefault',
                ti: '.CondenseScalarExprType.InterpolationDefault'
              }, {
                en: 'overlay',
                ti: '.CoverageExprPairType'
              }, {
                en: 'sqrt',
                ti: '.CoverageExprElementType'
              }, {
                en: 'not',
                ti: '.CoverageExprElementType'
              }, {
                en: 'identifier',
                ti: '.CoverageExprElementType'
              }, {
                en: 'DomainMetadata',
                ti: '.DomainMetadataExprType'
              }, {
                en: 'unaryMinus',
                ti: '.CoverageExprElementType'
              }, {
                en: 'bit',
                ti: '.CondenseScalarExprType.InterpolationSet.Bit'
              }, {
                en: 'add',
                ti: '.CoverageExprElementType'
              }, {
                en: 'some',
                ti: '.CoverageExprElementType'
              }, {
                en: 'crsTransform',
                ti: '.CrsTransformCoverageExprType'
              }, {
                en: 'construct',
                ti: '.ConstructCoverageExprType'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'CondenseScalarExprType.InterpolationDefault',
        tn: null,
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'name',
            rq: true
          }]
      }, {
        ln: 'ConstantType',
        ps: [{
            n: 'stringConstant',
            rq: true
          }, {
            n: 'booleanConstant',
            rq: true,
            ti: 'Boolean'
          }, {
            n: 'integerConstant',
            rq: true,
            ti: 'Integer'
          }, {
            n: 'floatConstant',
            rq: true,
            ti: 'Double'
          }, {
            n: 'complexConstant',
            rq: true,
            ti: '.ComplexConstantType'
          }]
      }, {
        ln: 'CondenseScalarExprType.InterpolationSet.FieldSelect',
        tn: null,
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'field',
            rq: true,
            ti: '.FieldNameType'
          }]
      }, {
        ln: 'CoverageExprElementType',
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }]
      }, {
        ln: 'ConstructCoverageExprType',
        ps: [{
            n: 'name',
            rq: true
          }, {
            n: 'axisIterator',
            rq: true,
            col: true,
            ti: '.AxisIteratorType'
          }, {
            n: 'identifier',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'imageCrs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'imageCrsDomain',
            rq: true,
            ti: '.CondenseScalarExprType.ImageCrsDomain'
          }, {
            n: 'crsSet',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'domainMetadata',
            rq: true,
            en: 'DomainMetadata',
            ti: '.DomainMetadataExprType'
          }, {
            n: 'nullSet',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'interpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationDefault'
          }, {
            n: 'interpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet'
          }, {
            n: 'booleanConstant',
            rq: true,
            ti: 'Boolean'
          }, {
            n: 'booleanNot',
            rq: true,
            ti: '.BooleanScalarExprType'
          }, {
            n: 'booleanAnd',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanOr',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanXor',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanLessThan',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanLessOrEqual',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanGreaterThan',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanGreaterOrEqual',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanEqualNumeric',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanNotEqualNumeric',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanEqualString',
            rq: true,
            ti: '.StringScalarExprPairType'
          }, {
            n: 'booleanNotEqualString',
            rq: true,
            ti: '.StringScalarExprPairType'
          }, {
            n: 'numericConstant',
            rq: true,
            ti: 'Double'
          }, {
            n: 'complexConstant',
            rq: true,
            ti: '.ComplexConstantType'
          }, {
            n: 'numericUnaryMinus',
            rq: true,
            ti: '.CondenseScalarExprType.NumericUnaryMinus'
          }, {
            n: 'numericAdd',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'numericMinus',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'numericMult',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'numericDiv',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'condense',
            rq: true,
            ti: '.CondenseScalarExprType'
          }, {
            n: 'reduce',
            rq: true,
            ti: '.ReduceScalarExprType'
          }, {
            n: 'all',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'some',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'count',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'add',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'avg',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'min',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'max',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'stringIdentifier',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'stringConstant',
            rq: true
          }]
      }, {
        ln: 'ComplexConstantType',
        ps: [{
            n: 're',
            rq: true,
            ti: 'Double'
          }, {
            n: 'im',
            rq: true,
            ti: 'Double'
          }]
      }, {
        ln: 'RangeCoverageExprType.Component',
        tn: null,
        ps: [{
            n: 'field',
            rq: true,
            ti: '.FieldNameType'
          }, {
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }]
      }, {
        ln: 'ProcessCoverageXmlRequestType.Where',
        tn: null,
        ps: [{
            n: 'booleanConstant',
            rq: true,
            ti: 'Boolean'
          }, {
            n: 'booleanNot',
            rq: true,
            ti: '.BooleanScalarExprType'
          }, {
            n: 'booleanAnd',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanOr',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanXor',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanLessThan',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanLessOrEqual',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanGreaterThan',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanGreaterOrEqual',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanEqualNumeric',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanNotEqualNumeric',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanEqualString',
            rq: true,
            ti: '.StringScalarExprPairType'
          }, {
            n: 'booleanNotEqualString',
            rq: true,
            ti: '.StringScalarExprPairType'
          }]
      }, {
        ln: 'CondenseScalarExprType.InterpolationSet.SetInterpolationDefault',
        tn: null,
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'field',
            rq: true,
            ti: '.FieldNameType'
          }, {
            n: 'interpolationMethod',
            rq: true
          }, {
            n: 'nullResistance',
            rq: true
          }]
      }, {
        ln: 'CondenseScalarExprType.ImageCrsDomain',
        tn: null,
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'axis'
          }]
      }, {
        ln: 'ProcessOneCoverageType',
        ps: [{
            n: 'xmlSyntax',
            rq: true,
            ti: '.ProcessCoverageXmlRequestType'
          }, {
            n: 'abstractSyntax',
            rq: true
          }]
      }, {
        ln: 'StringScalarExprPairType',
        ps: [{
            n: 'content',
            rq: true,
            mno: 2,
            mxo: 2,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'stringConstant'
              }, {
                en: 'stringIdentifier',
                ti: '.CoverageExprElementType'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'CondenseScalarExprType.InterpolationSet.Bit',
        tn: null,
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'bitIndex',
            rq: true,
            ti: 'Integer'
          }]
      }, {
        ln: 'TrimCoverageExprType',
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'dimensionIntervalElementType',
            rq: true,
            mno: 3,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'construct',
                ti: '.ConstructCoverageExprType'
              }, {
                en: 'cast',
                ti: '.CondenseScalarExprType.InterpolationSet.Cast'
              }, {
                en: 'overlay',
                ti: '.CoverageExprPairType'
              }, {
                en: 'exp',
                ti: '.CoverageExprElementType'
              }, {
                en: 'div',
                ti: '.CoverageExprPairType'
              }, {
                en: 'tan',
                ti: '.CoverageExprElementType'
              }, {
                en: 'mult',
                ti: '.CoverageExprPairType'
              }, {
                en: 'unaryPlus',
                ti: '.CoverageExprElementType'
              }, {
                en: 'setNullSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
              }, {
                en: 'rangeConstructor',
                ti: '.RangeCoverageExprType'
              }, {
                en: 'setInterpolationSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
              }, {
                en: 'unaryMinus',
                ti: '.CoverageExprElementType'
              }, {
                en: 'greaterOrEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'setIdentifier',
                ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
              }, {
                en: 'bit',
                ti: '.CondenseScalarExprType.InterpolationSet.Bit'
              }, {
                en: 'arccos',
                ti: '.CoverageExprElementType'
              }, {
                en: 'xor',
                ti: '.CoverageExprPairType'
              }, {
                en: 'and',
                ti: '.CoverageExprPairType'
              }, {
                en: 'notEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'tanh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'const',
                ti: '.ConstantCoverageExprType'
              }, {
                en: 'im',
                ti: '.CoverageExprElementType'
              }, {
                en: 'or',
                ti: '.CoverageExprPairType'
              }, {
                en: 'slice',
                ti: '.SliceCoverageExprType'
              }, {
                en: 'arctan',
                ti: '.CoverageExprElementType'
              }, {
                en: 'sinh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'sin',
                ti: '.CoverageExprElementType'
              }, {
                en: 'cosh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'axis'
              }, {
                en: 'sqrt',
                ti: '.CoverageExprElementType'
              }, {
                en: 'setInterpolationDefault',
                ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
              }, {
                en: 'fieldSelect',
                ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
              }, {
                en: 'minus',
                ti: '.CoverageExprPairType'
              }, {
                en: 'trim',
                ti: '.TrimCoverageExprType'
              }, {
                en: 'abs',
                ti: '.CoverageExprElementType'
              }, {
                en: 'plus',
                ti: '.CoverageExprPairType'
              }, {
                en: 'equals',
                ti: '.CoverageExprPairType'
              }, {
                en: 'log',
                ti: '.CoverageExprElementType'
              }, {
                en: 'arcsin',
                ti: '.CoverageExprElementType'
              }, {
                en: 'ln',
                ti: '.CoverageExprElementType'
              }, {
                en: 'not',
                ti: '.CoverageExprElementType'
              }, {
                en: 'cos',
                ti: '.CoverageExprElementType'
              }, {
                en: 'crsTransform',
                ti: '.CrsTransformCoverageExprType'
              }, {
                en: 'upperBound',
                ti: '.ScalarExprType'
              }, {
                en: 'lowerBound',
                ti: '.ScalarExprType'
              }, {
                en: {
                  lp: 'srsName',
                  ns: 'http:\/\/www.opengis.net\/gml'
                },
                ti: 'GML_3_1_1.CodeType'
              }, {
                en: 'coverage'
              }, {
                en: 'lessOrEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'extend',
                ti: '.ExtendCoverageExprType'
              }, {
                en: 'greaterThan',
                ti: '.CoverageExprPairType'
              }, {
                en: 'setCrsSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
              }, {
                en: 're',
                ti: '.CoverageExprElementType'
              }, {
                en: 'scale',
                ti: '.ScaleCoverageExprType'
              }, {
                en: 'lessThan',
                ti: '.CoverageExprPairType'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'CondenseScalarExprType',
        ps: [{
            n: 'content',
            rq: true,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'opAnd',
                ti: 'AnyType'
              }, {
                en: 'min',
                ti: '.CoverageExprElementType'
              }, {
                en: 'identifier',
                ti: '.CoverageExprElementType'
              }, {
                en: 'add',
                ti: '.CoverageExprElementType'
              }, {
                en: 'iterator',
                ti: '.AxisIteratorType'
              }, {
                en: 'crsSet',
                ti: '.CoverageExprElementType'
              }, {
                en: 'avg',
                ti: '.CoverageExprElementType'
              }, {
                en: 'reduce',
                ti: '.ReduceScalarExprType'
              }, {
                en: 'booleanEqualNumeric',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'some',
                ti: '.CoverageExprElementType'
              }, {
                en: 'booleanConstant',
                ti: 'Boolean'
              }, {
                en: 'count',
                ti: '.CoverageExprElementType'
              }, {
                en: 'numericConstant',
                ti: 'Double'
              }, {
                en: 'numericMinus',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'opMult',
                ti: 'AnyType'
              }, {
                en: 'booleanGreaterOrEqual',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'booleanLessOrEqual',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'numericMult',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'condense',
                ti: '.CondenseScalarExprType'
              }, {
                en: 'booleanGreaterThan',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'booleanXor',
                ti: '.BooleanScalarExprPairType'
              }, {
                en: 'nullSet',
                ti: '.CoverageExprElementType'
              }, {
                en: 'imageCrsDomain',
                ti: '.CondenseScalarExprType.ImageCrsDomain'
              }, {
                en: 'booleanOr',
                ti: '.BooleanScalarExprPairType'
              }, {
                en: 'numericDiv',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'opMin',
                ti: 'AnyType'
              }, {
                en: 'imageCrs',
                ti: '.CoverageExprElementType'
              }, {
                en: 'DomainMetadata',
                ti: '.DomainMetadataExprType'
              }, {
                en: 'booleanEqualString',
                ti: '.StringScalarExprPairType'
              }, {
                en: 'booleanLessThan',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'complexConstant',
                ti: '.ComplexConstantType'
              }, {
                en: 'interpolationDefault',
                ti: '.CondenseScalarExprType.InterpolationDefault'
              }, {
                en: 'max',
                ti: '.CoverageExprElementType'
              }, {
                en: 'booleanAnd',
                ti: '.BooleanScalarExprPairType'
              }, {
                en: 'opMax',
                ti: 'AnyType'
              }, {
                en: 'interpolationSet',
                ti: '.CondenseScalarExprType.InterpolationSet'
              }, {
                en: 'stringIdentifier',
                ti: '.CoverageExprElementType'
              }, {
                en: 'numericAdd',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'numericUnaryMinus',
                ti: '.CondenseScalarExprType.NumericUnaryMinus'
              }, {
                en: 'booleanNotEqualNumeric',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'all',
                ti: '.CoverageExprElementType'
              }, {
                en: 'opPlus',
                ti: 'AnyType'
              }, {
                en: 'booleanNotEqualString',
                ti: '.StringScalarExprPairType'
              }, {
                en: 'opOr',
                ti: 'AnyType'
              }, {
                en: 'where',
                ti: '.BooleanScalarExprType'
              }, {
                en: 'stringConstant'
              }, {
                en: 'booleanNot',
                ti: '.BooleanScalarExprType'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'CondenseScalarExprType.InterpolationSet',
        tn: null,
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'name',
            rq: true
          }]
      }, {
        ln: 'AxisIteratorType',
        ps: [{
            n: 'content',
            rq: true,
            mno: 4,
            mxo: 4,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'const',
                ti: '.ConstantCoverageExprType'
              }, {
                en: 'axis'
              }, {
                en: 'greaterOrEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'condense',
                ti: '.CondenseScalarExprType'
              }, {
                en: 'bit',
                ti: '.CondenseScalarExprType.InterpolationSet.Bit'
              }, {
                en: 'arcsin',
                ti: '.CoverageExprElementType'
              }, {
                en: 'equals',
                ti: '.CoverageExprPairType'
              }, {
                en: 'im',
                ti: '.CoverageExprElementType'
              }, {
                en: 'overlay',
                ti: '.CoverageExprPairType'
              }, {
                en: 'reduce',
                ti: '.ReduceScalarExprType'
              }, {
                en: 'plus',
                ti: '.CoverageExprPairType'
              }, {
                en: 'tan',
                ti: '.CoverageExprElementType'
              }, {
                en: 'numericMult',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'log',
                ti: '.CoverageExprElementType'
              }, {
                en: 'unaryPlus',
                ti: '.CoverageExprElementType'
              }, {
                en: 'sqrt',
                ti: '.CoverageExprElementType'
              }, {
                en: 'mult',
                ti: '.CoverageExprPairType'
              }, {
                en: 'abs',
                ti: '.CoverageExprElementType'
              }, {
                en: 'numericConstant',
                ti: 'Double'
              }, {
                en: 'arctan',
                ti: '.CoverageExprElementType'
              }, {
                en: 're',
                ti: '.CoverageExprElementType'
              }, {
                en: 'extend',
                ti: '.ExtendCoverageExprType'
              }, {
                en: 'fieldSelect',
                ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
              }, {
                en: 'and',
                ti: '.CoverageExprPairType'
              }, {
                en: 'trim',
                ti: '.TrimCoverageExprType'
              }, {
                en: 'unaryMinus',
                ti: '.CoverageExprElementType'
              }, {
                en: 'numericUnaryMinus',
                ti: '.CondenseScalarExprType.NumericUnaryMinus'
              }, {
                en: 'construct',
                ti: '.ConstructCoverageExprType'
              }, {
                en: 'not',
                ti: '.CoverageExprElementType'
              }, {
                en: 'notEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'setInterpolationDefault',
                ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
              }, {
                en: 'minus',
                ti: '.CoverageExprPairType'
              }, {
                en: 'setCrsSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
              }, {
                en: 'iteratorVar'
              }, {
                en: 'xor',
                ti: '.CoverageExprPairType'
              }, {
                en: 'rangeConstructor',
                ti: '.RangeCoverageExprType'
              }, {
                en: 'cast',
                ti: '.CondenseScalarExprType.InterpolationSet.Cast'
              }, {
                en: 'setInterpolationSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
              }, {
                en: 'numericDiv',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'slice',
                ti: '.SliceCoverageExprType'
              }, {
                en: 'numericAdd',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'lessOrEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'crsTransform',
                ti: '.CrsTransformCoverageExprType'
              }, {
                en: 'numericMinus',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'scale',
                ti: '.ScaleCoverageExprType'
              }, {
                en: 'arccos',
                ti: '.CoverageExprElementType'
              }, {
                en: 'sinh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'div',
                ti: '.CoverageExprPairType'
              }, {
                en: 'ln',
                ti: '.CoverageExprElementType'
              }, {
                en: 'cosh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'sin',
                ti: '.CoverageExprElementType'
              }, {
                en: 'exp',
                ti: '.CoverageExprElementType'
              }, {
                en: 'greaterThan',
                ti: '.CoverageExprPairType'
              }, {
                en: 'complexConstant',
                ti: '.ComplexConstantType'
              }, {
                en: 'coverage'
              }, {
                en: 'setNullSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
              }, {
                en: 'setIdentifier',
                ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
              }, {
                en: 'cos',
                ti: '.CoverageExprElementType'
              }, {
                en: 'tanh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'or',
                ti: '.CoverageExprPairType'
              }, {
                en: 'lessThan',
                ti: '.CoverageExprPairType'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'CondenseScalarExprType.InterpolationSet.SetIdentifier',
        tn: null,
        ps: [{
            n: 'identifier',
            rq: true
          }, {
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }]
      }, {
        ln: 'ConstantCoverageExprType',
        ps: [{
            n: 'name',
            rq: true
          }, {
            n: 'axisIterator',
            rq: true,
            col: true,
            ti: '.AxisIteratorType'
          }, {
            n: 'value',
            rq: true,
            col: true,
            ti: '.ConstantType'
          }]
      }, {
        ln: 'RangeExprType',
        ps: [{
            n: 'component',
            rq: true,
            col: true,
            ti: '.RangeExprType.Component'
          }]
      }, {
        ln: 'FieldNameType',
        ps: [{
            n: 'name',
            rq: true
          }]
      }, {
        ln: 'EncodeDataExprType',
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'format',
            rq: true
          }, {
            n: 'extraParameters'
          }, {
            n: 'store',
            ti: 'Boolean',
            an: {
              lp: 'store'
            },
            t: 'a'
          }]
      }, {
        ln: 'BooleanScalarExprPairType',
        ps: [{
            n: 'content',
            rq: true,
            mno: 2,
            mxo: 2,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'booleanAnd',
                ti: '.BooleanScalarExprPairType'
              }, {
                en: 'booleanNotEqualNumeric',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'booleanEqualNumeric',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'booleanLessOrEqual',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'booleanNotEqualString',
                ti: '.StringScalarExprPairType'
              }, {
                en: 'booleanOr',
                ti: '.BooleanScalarExprPairType'
              }, {
                en: 'booleanEqualString',
                ti: '.StringScalarExprPairType'
              }, {
                en: 'booleanGreaterOrEqual',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'booleanConstant',
                ti: 'Boolean'
              }, {
                en: 'booleanGreaterThan',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'booleanLessThan',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'booleanXor',
                ti: '.BooleanScalarExprPairType'
              }, {
                en: 'booleanNot',
                ti: '.BooleanScalarExprType'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'NumericScalarExprPairType',
        ps: [{
            n: 'content',
            rq: true,
            mno: 2,
            mxo: 2,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'condense',
                ti: '.CondenseScalarExprType'
              }, {
                en: 'reduce',
                ti: '.ReduceScalarExprType'
              }, {
                en: 'numericConstant',
                ti: 'Double'
              }, {
                en: 'numericDiv',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'numericMult',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'numericAdd',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'complexConstant',
                ti: '.ComplexConstantType'
              }, {
                en: 'numericMinus',
                ti: '.NumericScalarExprPairType'
              }, {
                en: 'numericUnaryMinus',
                ti: '.CondenseScalarExprType.NumericUnaryMinus'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'ProcessCoverageXmlRequestType.CoverageIterator',
        tn: null,
        ps: [{
            n: 'iteratorVar',
            rq: true
          }, {
            n: 'coverageName',
            mno: 0,
            col: true
          }]
      }, {
        ln: 'ScaleCoverageExprType',
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'dimensionIntervalElementType',
            rq: true,
            mno: 3,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'mult',
                ti: '.CoverageExprPairType'
              }, {
                en: 'construct',
                ti: '.ConstructCoverageExprType'
              }, {
                en: 'log',
                ti: '.CoverageExprElementType'
              }, {
                en: 'fieldSelect',
                ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
              }, {
                en: 'div',
                ti: '.CoverageExprPairType'
              }, {
                en: 'setIdentifier',
                ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
              }, {
                en: 'or',
                ti: '.CoverageExprPairType'
              }, {
                en: 'minus',
                ti: '.CoverageExprPairType'
              }, {
                en: 'setInterpolationDefault',
                ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
              }, {
                en: 'abs',
                ti: '.CoverageExprElementType'
              }, {
                en: 'coverage'
              }, {
                en: 'const',
                ti: '.ConstantCoverageExprType'
              }, {
                en: 'setInterpolationSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
              }, {
                en: 'bit',
                ti: '.CondenseScalarExprType.InterpolationSet.Bit'
              }, {
                en: 'cos',
                ti: '.CoverageExprElementType'
              }, {
                en: 'not',
                ti: '.CoverageExprElementType'
              }, {
                en: 'setNullSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
              }, {
                en: 'tanh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'sin',
                ti: '.CoverageExprElementType'
              }, {
                en: 'slice',
                ti: '.SliceCoverageExprType'
              }, {
                en: 'scale',
                ti: '.ScaleCoverageExprType'
              }, {
                en: 'plus',
                ti: '.CoverageExprPairType'
              }, {
                en: 'trim',
                ti: '.TrimCoverageExprType'
              }, {
                en: 're',
                ti: '.CoverageExprElementType'
              }, {
                en: 'tan',
                ti: '.CoverageExprElementType'
              }, {
                en: 'sinh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'xor',
                ti: '.CoverageExprPairType'
              }, {
                en: 'lowerBound',
                ti: '.ScalarExprType'
              }, {
                en: 'rangeConstructor',
                ti: '.RangeCoverageExprType'
              }, {
                en: 'exp',
                ti: '.CoverageExprElementType'
              }, {
                en: 'unaryPlus',
                ti: '.CoverageExprElementType'
              }, {
                en: 'greaterOrEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'lessThan',
                ti: '.CoverageExprPairType'
              }, {
                en: 'arccos',
                ti: '.CoverageExprElementType'
              }, {
                en: 'sqrt',
                ti: '.CoverageExprElementType'
              }, {
                en: 'ln',
                ti: '.CoverageExprElementType'
              }, {
                en: 'lessOrEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'setCrsSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
              }, {
                en: 'extend',
                ti: '.ExtendCoverageExprType'
              }, {
                en: 'notEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'and',
                ti: '.CoverageExprPairType'
              }, {
                en: 'overlay',
                ti: '.CoverageExprPairType'
              }, {
                en: 'cast',
                ti: '.CondenseScalarExprType.InterpolationSet.Cast'
              }, {
                en: 'unaryMinus',
                ti: '.CoverageExprElementType'
              }, {
                en: 'im',
                ti: '.CoverageExprElementType'
              }, {
                en: {
                  lp: 'srsName',
                  ns: 'http:\/\/www.opengis.net\/gml'
                },
                ti: 'GML_3_1_1.CodeType'
              }, {
                en: 'crsTransform',
                ti: '.CrsTransformCoverageExprType'
              }, {
                en: 'arctan',
                ti: '.CoverageExprElementType'
              }, {
                en: 'equals',
                ti: '.CoverageExprPairType'
              }, {
                en: 'axis'
              }, {
                en: 'greaterThan',
                ti: '.CoverageExprPairType'
              }, {
                en: 'upperBound',
                ti: '.ScalarExprType'
              }, {
                en: 'arcsin',
                ti: '.CoverageExprElementType'
              }, {
                en: 'cosh',
                ti: '.CoverageExprElementType'
              }],
            t: 'ers'
          }, {
            n: 'fieldInterpolationElementType',
            rq: true,
            mno: 3,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'name'
              }, {
                en: 'nullResistance'
              }, {
                en: 'interpolationMethod'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'DomainMetadataExprType',
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'axis',
            rq: true
          }, {
            n: 'srsName',
            rq: true,
            en: {
              lp: 'srsName',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.CodeType'
          }]
      }, {
        ln: 'ProcessCoverageXmlRequestType',
        ps: [{
            n: 'coverageIterator',
            rq: true,
            col: true,
            ti: '.ProcessCoverageXmlRequestType.CoverageIterator'
          }, {
            n: 'where',
            ti: '.ProcessCoverageXmlRequestType.Where'
          }, {
            n: 'encode',
            rq: true,
            ti: '.EncodeDataExprType'
          }, {
            n: 'identifier',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'imageCrs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'imageCrsDomain',
            rq: true,
            ti: '.CondenseScalarExprType.ImageCrsDomain'
          }, {
            n: 'crsSet',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'domainMetadata',
            rq: true,
            en: 'DomainMetadata',
            ti: '.DomainMetadataExprType'
          }, {
            n: 'nullSet',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'interpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationDefault'
          }, {
            n: 'interpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet'
          }, {
            n: 'booleanConstant',
            rq: true,
            ti: 'Boolean'
          }, {
            n: 'booleanNot',
            rq: true,
            ti: '.BooleanScalarExprType'
          }, {
            n: 'booleanAnd',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanOr',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanXor',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanLessThan',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanLessOrEqual',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanGreaterThan',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanGreaterOrEqual',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanEqualNumeric',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanNotEqualNumeric',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanEqualString',
            rq: true,
            ti: '.StringScalarExprPairType'
          }, {
            n: 'booleanNotEqualString',
            rq: true,
            ti: '.StringScalarExprPairType'
          }, {
            n: 'numericConstant',
            rq: true,
            ti: 'Double'
          }, {
            n: 'complexConstant',
            rq: true,
            ti: '.ComplexConstantType'
          }, {
            n: 'numericUnaryMinus',
            rq: true,
            ti: '.CondenseScalarExprType.NumericUnaryMinus'
          }, {
            n: 'numericAdd',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'numericMinus',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'numericMult',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'numericDiv',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'condense',
            rq: true,
            ti: '.CondenseScalarExprType'
          }, {
            n: 'reduce',
            rq: true,
            ti: '.ReduceScalarExprType'
          }, {
            n: 'all',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'some',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'count',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'add',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'avg',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'min',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'max',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'stringIdentifier',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'stringConstant',
            rq: true
          }]
      }, {
        ln: 'ProcessCoveragesRequestType',
        bti: 'WCS_1_1.RequestBaseType',
        ps: [{
            n: 'query',
            rq: true,
            ti: '.ProcessOneCoverageType'
          }]
      }, {
        ln: 'CondenseScalarExprType.InterpolationSet.SetCrsSet',
        tn: null,
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'crsNameType',
            mno: 0,
            col: true,
            en: {
              lp: 'srsName',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.CodeType'
          }]
      }, {
        ln: 'ExtendCoverageExprType',
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: 'dimensionIntervalElementType',
            rq: true,
            mno: 3,
            col: true,
            mx: false,
            dom: false,
            etis: [{
                en: 'setInterpolationSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
              }, {
                en: 'xor',
                ti: '.CoverageExprPairType'
              }, {
                en: 'tanh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'lessOrEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'cast',
                ti: '.CondenseScalarExprType.InterpolationSet.Cast'
              }, {
                en: 'plus',
                ti: '.CoverageExprPairType'
              }, {
                en: 'div',
                ti: '.CoverageExprPairType'
              }, {
                en: 'abs',
                ti: '.CoverageExprElementType'
              }, {
                en: 'upperBound',
                ti: '.ScalarExprType'
              }, {
                en: 'sin',
                ti: '.CoverageExprElementType'
              }, {
                en: 'exp',
                ti: '.CoverageExprElementType'
              }, {
                en: 'setInterpolationDefault',
                ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
              }, {
                en: 'coverage'
              }, {
                en: 'greaterThan',
                ti: '.CoverageExprPairType'
              }, {
                en: 'ln',
                ti: '.CoverageExprElementType'
              }, {
                en: 'sqrt',
                ti: '.CoverageExprElementType'
              }, {
                en: 'setIdentifier',
                ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
              }, {
                en: 'lessThan',
                ti: '.CoverageExprPairType'
              }, {
                en: 'equals',
                ti: '.CoverageExprPairType'
              }, {
                en: 'construct',
                ti: '.ConstructCoverageExprType'
              }, {
                en: 'im',
                ti: '.CoverageExprElementType'
              }, {
                en: 'arccos',
                ti: '.CoverageExprElementType'
              }, {
                en: 'cos',
                ti: '.CoverageExprElementType'
              }, {
                en: 'mult',
                ti: '.CoverageExprPairType'
              }, {
                en: 'setCrsSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
              }, {
                en: 'overlay',
                ti: '.CoverageExprPairType'
              }, {
                en: 'setNullSet',
                ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
              }, {
                en: 'crsTransform',
                ti: '.CrsTransformCoverageExprType'
              }, {
                en: 'and',
                ti: '.CoverageExprPairType'
              }, {
                en: 'tan',
                ti: '.CoverageExprElementType'
              }, {
                en: 'extend',
                ti: '.ExtendCoverageExprType'
              }, {
                en: 'greaterOrEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'lowerBound',
                ti: '.ScalarExprType'
              }, {
                en: 'arcsin',
                ti: '.CoverageExprElementType'
              }, {
                en: 'axis'
              }, {
                en: 'slice',
                ti: '.SliceCoverageExprType'
              }, {
                en: 're',
                ti: '.CoverageExprElementType'
              }, {
                en: 'notEqual',
                ti: '.CoverageExprPairType'
              }, {
                en: 'unaryMinus',
                ti: '.CoverageExprElementType'
              }, {
                en: 'sinh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'not',
                ti: '.CoverageExprElementType'
              }, {
                en: {
                  lp: 'srsName',
                  ns: 'http:\/\/www.opengis.net\/gml'
                },
                ti: 'GML_3_1_1.CodeType'
              }, {
                en: 'arctan',
                ti: '.CoverageExprElementType'
              }, {
                en: 'or',
                ti: '.CoverageExprPairType'
              }, {
                en: 'scale',
                ti: '.ScaleCoverageExprType'
              }, {
                en: 'log',
                ti: '.CoverageExprElementType'
              }, {
                en: 'minus',
                ti: '.CoverageExprPairType'
              }, {
                en: 'trim',
                ti: '.TrimCoverageExprType'
              }, {
                en: 'cosh',
                ti: '.CoverageExprElementType'
              }, {
                en: 'fieldSelect',
                ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
              }, {
                en: 'unaryPlus',
                ti: '.CoverageExprElementType'
              }, {
                en: 'bit',
                ti: '.CondenseScalarExprType.InterpolationSet.Bit'
              }, {
                en: 'rangeConstructor',
                ti: '.RangeCoverageExprType'
              }, {
                en: 'const',
                ti: '.ConstantCoverageExprType'
              }],
            t: 'ers'
          }]
      }, {
        ln: 'CondenseScalarExprType.NumericUnaryMinus',
        tn: null,
        ps: [{
            n: 'numericConstant',
            rq: true,
            ti: 'Double'
          }, {
            n: 'complexConstant',
            rq: true,
            ti: '.ComplexConstantType'
          }, {
            n: 'numericUnaryMinus',
            rq: true,
            ti: '.CondenseScalarExprType.NumericUnaryMinus'
          }, {
            n: 'numericAdd',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'numericMinus',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'numericMult',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'numericDiv',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'condense',
            rq: true,
            ti: '.CondenseScalarExprType'
          }, {
            n: 'reduce',
            rq: true,
            ti: '.ReduceScalarExprType'
          }]
      }, {
        ln: 'CondenseScalarExprType.InterpolationSet.SetNullSet',
        tn: null,
        ps: [{
            n: 'coverage',
            rq: true
          }, {
            n: 'setIdentifier',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier'
          }, {
            n: 'setCrsSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet'
          }, {
            n: 'setNullSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet'
          }, {
            n: 'setInterpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault'
          }, {
            n: 'setInterpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
          }, {
            n: 'unaryPlus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'unaryMinus',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sqrt',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'abs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'exp',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'log',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'ln',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'sinh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'cosh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'tanh',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arcsin',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arccos',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'arctan',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'not',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 're',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'im',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'bit',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Bit'
          }, {
            n: 'cast',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.Cast'
          }, {
            n: 'fieldSelect',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect'
          }, {
            n: 'plus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'minus',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'mult',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'div',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'and',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'or',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'xor',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'equals',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterThan',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'lessOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'greaterOrEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'notEqual',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'overlay',
            rq: true,
            ti: '.CoverageExprPairType'
          }, {
            n: 'rangeConstructor',
            rq: true,
            ti: '.RangeCoverageExprType'
          }, {
            n: 'trim',
            rq: true,
            ti: '.TrimCoverageExprType'
          }, {
            n: 'slice',
            rq: true,
            ti: '.SliceCoverageExprType'
          }, {
            n: 'extend',
            rq: true,
            ti: '.ExtendCoverageExprType'
          }, {
            n: 'crsTransform',
            rq: true,
            ti: '.CrsTransformCoverageExprType'
          }, {
            n: 'scale',
            rq: true,
            ti: '.ScaleCoverageExprType'
          }, {
            n: 'construct',
            rq: true,
            ti: '.ConstructCoverageExprType'
          }, {
            n: '_const',
            rq: true,
            en: 'const',
            ti: '.ConstantCoverageExprType'
          }, {
            n: '_null',
            mno: 0,
            col: true,
            en: 'null',
            ti: '.RangeExprType'
          }]
      }, {
        ln: 'BooleanScalarExprType',
        ps: [{
            n: 'booleanConstant',
            rq: true,
            ti: 'Boolean'
          }, {
            n: 'booleanNot',
            rq: true,
            ti: '.BooleanScalarExprType'
          }, {
            n: 'booleanAnd',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanOr',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanXor',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanLessThan',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanLessOrEqual',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanGreaterThan',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanGreaterOrEqual',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanEqualNumeric',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanNotEqualNumeric',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanEqualString',
            rq: true,
            ti: '.StringScalarExprPairType'
          }, {
            n: 'booleanNotEqualString',
            rq: true,
            ti: '.StringScalarExprPairType'
          }]
      }, {
        ln: 'RangeExprType.Component',
        tn: null,
        ps: [{
            n: 'field',
            rq: true,
            ti: '.FieldNameType'
          }, {
            n: 'identifier',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'imageCrs',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'imageCrsDomain',
            rq: true,
            ti: '.CondenseScalarExprType.ImageCrsDomain'
          }, {
            n: 'crsSet',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'domainMetadata',
            rq: true,
            en: 'DomainMetadata',
            ti: '.DomainMetadataExprType'
          }, {
            n: 'nullSet',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'interpolationDefault',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationDefault'
          }, {
            n: 'interpolationSet',
            rq: true,
            ti: '.CondenseScalarExprType.InterpolationSet'
          }, {
            n: 'booleanConstant',
            rq: true,
            ti: 'Boolean'
          }, {
            n: 'booleanNot',
            rq: true,
            ti: '.BooleanScalarExprType'
          }, {
            n: 'booleanAnd',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanOr',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanXor',
            rq: true,
            ti: '.BooleanScalarExprPairType'
          }, {
            n: 'booleanLessThan',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanLessOrEqual',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanGreaterThan',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanGreaterOrEqual',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanEqualNumeric',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanNotEqualNumeric',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'booleanEqualString',
            rq: true,
            ti: '.StringScalarExprPairType'
          }, {
            n: 'booleanNotEqualString',
            rq: true,
            ti: '.StringScalarExprPairType'
          }, {
            n: 'numericConstant',
            rq: true,
            ti: 'Double'
          }, {
            n: 'complexConstant',
            rq: true,
            ti: '.ComplexConstantType'
          }, {
            n: 'numericUnaryMinus',
            rq: true,
            ti: '.CondenseScalarExprType.NumericUnaryMinus'
          }, {
            n: 'numericAdd',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'numericMinus',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'numericMult',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'numericDiv',
            rq: true,
            ti: '.NumericScalarExprPairType'
          }, {
            n: 'condense',
            rq: true,
            ti: '.CondenseScalarExprType'
          }, {
            n: 'reduce',
            rq: true,
            ti: '.ReduceScalarExprType'
          }, {
            n: 'all',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'some',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'count',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'add',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'avg',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'min',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'max',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'stringIdentifier',
            rq: true,
            ti: '.CoverageExprElementType'
          }, {
            n: 'stringConstant',
            rq: true
          }]
      }, {
        t: 'enum',
        ln: 'AxisNameType',
        vs: ['x', 'y', 'z', 't']
      }, {
        t: 'enum',
        ln: 'RangeFieldType',
        vs: ['bool', 'char', 'unsigned char', 'short', 'unsigned short', 'long', 'unsigned long', 'float', 'double', 'complex', 'complex2']
      }],
    eis: [{
        en: 'booleanGreaterThan',
        ti: '.NumericScalarExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'not',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'arccos',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'booleanEqualNumeric',
        ti: '.NumericScalarExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'tan',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'unaryMinus',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'trim',
        ti: '.TrimCoverageExprType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'ln',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'sinh',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'numericMult',
        ti: '.NumericScalarExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'stringConstant',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'and',
        ti: '.CoverageExprPairType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'DomainMetadata',
        ti: '.DomainMetadataExprType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'sin',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'extend',
        ti: '.ExtendCoverageExprType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'condense',
        ti: '.CondenseScalarExprType',
        sc: '.AxisIteratorType'
      }, {
        en: 'crsTransform',
        ti: '.CrsTransformCoverageExprType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'sqrt',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'and',
        ti: '.CoverageExprPairType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'booleanEqualNumeric',
        ti: '.NumericScalarExprPairType',
        sc: '.BooleanScalarExprPairType'
      }, {
        en: 'sinh',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'booleanAnd',
        ti: '.BooleanScalarExprPairType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'booleanGreaterOrEqual',
        ti: '.NumericScalarExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'crsTransform',
        ti: '.CrsTransformCoverageExprType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'iteratorVar',
        sc: '.AxisIteratorType'
      }, {
        en: 'arccos',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'cosh',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'cosh',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'rangeConstructor',
        ti: '.RangeCoverageExprType',
        sc: '.AxisIteratorType'
      }, {
        en: 'booleanEqualString',
        ti: '.StringScalarExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'overlay',
        ti: '.CoverageExprPairType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'booleanLessOrEqual',
        ti: '.NumericScalarExprPairType',
        sc: '.BooleanScalarExprPairType'
      }, {
        en: 'const',
        ti: '.ConstantCoverageExprType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'numericAdd',
        ti: '.NumericScalarExprPairType',
        sc: '.NumericScalarExprPairType'
      }, {
        en: 'log',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'numericConstant',
        ti: 'Double',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'log',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'interpolationDefault',
        ti: '.CondenseScalarExprType.InterpolationDefault',
        sc: '.CoverageExprPairType'
      }, {
        en: 'notEqual',
        ti: '.CoverageExprPairType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'count',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'cosh',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'and',
        ti: '.CoverageExprPairType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'fieldSelect',
        ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'slice',
        ti: '.SliceCoverageExprType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'tan',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'lessThan',
        ti: '.CoverageExprPairType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'booleanLessThan',
        ti: '.NumericScalarExprPairType',
        sc: '.BooleanScalarExprPairType'
      }, {
        en: 'stringIdentifier',
        ti: '.CoverageExprElementType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'booleanAnd',
        ti: '.BooleanScalarExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'div',
        ti: '.CoverageExprPairType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'sin',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'booleanNot',
        ti: '.BooleanScalarExprType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'unaryMinus',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'slice',
        ti: '.SliceCoverageExprType',
        sc: '.AxisIteratorType'
      }, {
        en: 'fieldSelect',
        ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'sinh',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'unaryMinus',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'minus',
        ti: '.CoverageExprPairType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'max',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'interpolationMethod',
        sc: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
      }, {
        en: 'setIdentifier',
        ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'avg',
        ti: '.CoverageExprElementType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'extend',
        ti: '.ExtendCoverageExprType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'sin',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'booleanNotEqualString',
        ti: '.StringScalarExprPairType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'ln',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'sqrt',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'notEqual',
        ti: '.CoverageExprPairType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'div',
        ti: '.CoverageExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'complexConstant',
        ti: '.ComplexConstantType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'reduce',
        ti: '.ReduceScalarExprType',
        sc: '.NumericScalarExprPairType'
      }, {
        en: 'equals',
        ti: '.CoverageExprPairType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'greaterThan',
        ti: '.CoverageExprPairType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'and',
        ti: '.CoverageExprPairType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'opMin',
        ti: 'AnyType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'axis',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'xor',
        ti: '.CoverageExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'or',
        ti: '.CoverageExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'reduce',
        ti: '.ReduceScalarExprType',
        sc: '.AxisIteratorType'
      }, {
        en: 'im',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'setInterpolationSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'setInterpolationDefault',
        ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'unaryMinus',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'coverage',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'log',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'im',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'arccos',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'setNullSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'notEqual',
        ti: '.CoverageExprPairType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'setInterpolationSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet',
        sc: '.CoverageExprPairType'
      }, {
        en: 'complexConstant',
        ti: '.ComplexConstantType',
        sc: '.NumericScalarExprPairType'
      }, {
        en: 'numericUnaryMinus',
        ti: '.CondenseScalarExprType.NumericUnaryMinus',
        sc: '.CoverageExprPairType'
      }, {
        en: 'sinh',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'reduce',
        ti: '.ReduceScalarExprType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'equals',
        ti: '.CoverageExprPairType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'exp',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'cos',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'imageCrs',
        ti: '.CoverageExprElementType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'cast',
        ti: '.CondenseScalarExprType.InterpolationSet.Cast',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'booleanGreaterOrEqual',
        ti: '.NumericScalarExprPairType',
        sc: '.BooleanScalarExprPairType'
      }, {
        en: 'opAnd',
        ti: 'AnyType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'arctan',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'xor',
        ti: '.CoverageExprPairType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'slice',
        ti: '.SliceCoverageExprType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'cos',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'setInterpolationDefault',
        ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'all',
        ti: '.CoverageExprElementType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'coverage',
        sc: '.CoverageExprPairType'
      }, {
        en: 'add',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'trim',
        ti: '.TrimCoverageExprType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'not',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'coverage',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'setCrsSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'sqrt',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'or',
        ti: '.CoverageExprPairType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'plus',
        ti: '.CoverageExprPairType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'cos',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'DomainMetadata',
        ti: '.DomainMetadataExprType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'mult',
        ti: '.CoverageExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'arcsin',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'const',
        ti: '.ConstantCoverageExprType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'complexConstant',
        ti: '.ComplexConstantType',
        sc: '.AxisIteratorType'
      }, {
        en: 'construct',
        ti: '.ConstructCoverageExprType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'rangeConstructor',
        ti: '.RangeCoverageExprType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'nullSet',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'tan',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'const',
        ti: '.ConstantCoverageExprType',
        sc: '.AxisIteratorType'
      }, {
        en: 'count',
        ti: '.CoverageExprElementType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'unaryPlus',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'axis',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'numericAdd',
        ti: '.NumericScalarExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'setInterpolationSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'bit',
        ti: '.CondenseScalarExprType.InterpolationSet.Bit',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'lowerBound',
        ti: '.ScalarExprType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'booleanXor',
        ti: '.BooleanScalarExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'tanh',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'abs',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'im',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'numericMinus',
        ti: '.NumericScalarExprPairType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'im',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'trim',
        ti: '.TrimCoverageExprType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'bit',
        ti: '.CondenseScalarExprType.InterpolationSet.Bit',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'slice',
        ti: '.SliceCoverageExprType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'setCrsSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'cast',
        ti: '.CondenseScalarExprType.InterpolationSet.Cast',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'axis',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'sqrt',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'slice',
        ti: '.SliceCoverageExprType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'booleanGreaterThan',
        ti: '.NumericScalarExprPairType',
        sc: '.BooleanScalarExprPairType'
      }, {
        en: 'xor',
        ti: '.CoverageExprPairType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'lessOrEqual',
        ti: '.CoverageExprPairType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'booleanEqualString',
        ti: '.StringScalarExprPairType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'tanh',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'booleanOr',
        ti: '.BooleanScalarExprPairType',
        sc: '.BooleanScalarExprPairType'
      }, {
        en: 'equals',
        ti: '.CoverageExprPairType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'construct',
        ti: '.ConstructCoverageExprType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'minus',
        ti: '.CoverageExprPairType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'booleanXor',
        ti: '.BooleanScalarExprPairType',
        sc: '.BooleanScalarExprPairType'
      }, {
        en: 'not',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'or',
        ti: '.CoverageExprPairType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'interpolationDefault',
        ti: '.CondenseScalarExprType.InterpolationDefault',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'setCrsSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'construct',
        ti: '.ConstructCoverageExprType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'condense',
        ti: '.CondenseScalarExprType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'ln',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'booleanNotEqualNumeric',
        ti: '.NumericScalarExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'crsSet',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'booleanEqualNumeric',
        ti: '.NumericScalarExprPairType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'setIdentifier',
        ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'crsTransform',
        ti: '.CrsTransformCoverageExprType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'exp',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'lessThan',
        ti: '.CoverageExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'exp',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'construct',
        ti: '.ConstructCoverageExprType',
        sc: '.AxisIteratorType'
      }, {
        en: 'booleanNot',
        ti: '.BooleanScalarExprType',
        sc: '.BooleanScalarExprPairType'
      }, {
        en: 'arccos',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'setNullSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'condense',
        ti: '.CondenseScalarExprType',
        sc: '.NumericScalarExprPairType'
      }, {
        en: 'greaterOrEqual',
        ti: '.CoverageExprPairType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'setIdentifier',
        ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'greaterThan',
        ti: '.CoverageExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'condense',
        ti: '.CondenseScalarExprType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'booleanLessThan',
        ti: '.NumericScalarExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'log',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'not',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'not',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'complexConstant',
        ti: '.ComplexConstantType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'sin',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'setNullSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'or',
        ti: '.CoverageExprPairType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'tan',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'setCrsSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'identifier',
        ti: '.CoverageExprElementType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'axis',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'crsTransform',
        ti: '.CrsTransformCoverageExprType',
        sc: '.AxisIteratorType'
      }, {
        en: 'booleanGreaterThan',
        ti: '.NumericScalarExprPairType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'numericDiv',
        ti: '.NumericScalarExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'numericAdd',
        ti: '.NumericScalarExprPairType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'rangeConstructor',
        ti: '.RangeCoverageExprType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'lessOrEqual',
        ti: '.CoverageExprPairType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'lowerBound',
        ti: '.ScalarExprType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'fieldSelect',
        ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect',
        sc: '.CoverageExprPairType'
      }, {
        en: 'arctan',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'nullResistance',
        sc: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet'
      }, {
        en: 'arctan',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'fieldSelect',
        ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'numericConstant',
        ti: 'Double',
        sc: '.NumericScalarExprPairType'
      }, {
        en: 'tan',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'add',
        ti: '.CoverageExprElementType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'opOr',
        ti: 'AnyType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'const',
        ti: '.ConstantCoverageExprType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'numericDiv',
        ti: '.NumericScalarExprPairType',
        sc: '.NumericScalarExprPairType'
      }, {
        en: 'notEqual',
        ti: '.CoverageExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 're',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'setInterpolationDefault',
        ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'overlay',
        ti: '.CoverageExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'lowerBound',
        ti: '.ScalarExprType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'coverage',
        sc: '.AxisIteratorType'
      }, {
        en: 'booleanNot',
        ti: '.BooleanScalarExprType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'minus',
        ti: '.CoverageExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'trim',
        ti: '.TrimCoverageExprType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'setInterpolationDefault',
        ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault',
        sc: '.CoverageExprPairType'
      }, {
        en: 'numericMult',
        ti: '.NumericScalarExprPairType',
        sc: '.NumericScalarExprPairType'
      }, {
        en: 'all',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'cast',
        ti: '.CondenseScalarExprType.InterpolationSet.Cast',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'sqrt',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'arctan',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'setNullSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'numericMult',
        ti: '.NumericScalarExprPairType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'not',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'scale',
        ti: '.ScaleCoverageExprType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'tanh',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'iterator',
        ti: '.AxisIteratorType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'equals',
        ti: '.CoverageExprPairType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'nullSet',
        ti: '.CoverageExprElementType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'minus',
        ti: '.CoverageExprPairType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'numericAdd',
        ti: '.NumericScalarExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'setInterpolationDefault',
        ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault',
        sc: '.AxisIteratorType'
      }, {
        en: 're',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'name',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'max',
        ti: '.CoverageExprElementType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'minus',
        ti: '.CoverageExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'setIdentifier',
        ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier',
        sc: '.AxisIteratorType'
      }, {
        en: 'lessThan',
        ti: '.CoverageExprPairType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'cosh',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'arccos',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'div',
        ti: '.CoverageExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'bit',
        ti: '.CondenseScalarExprType.InterpolationSet.Bit',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'reduce',
        ti: '.ReduceScalarExprType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'coverage',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'cast',
        ti: '.CondenseScalarExprType.InterpolationSet.Cast',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'stringConstant',
        sc: '.StringScalarExprPairType'
      }, {
        en: 'plus',
        ti: '.CoverageExprPairType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'nullResistance',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'booleanNotEqualNumeric',
        ti: '.NumericScalarExprPairType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'identifier',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'sinh',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'sinh',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'interpolationSet',
        ti: '.CondenseScalarExprType.InterpolationSet',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'setNullSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet',
        sc: '.AxisIteratorType'
      }, {
        en: 'numericMult',
        ti: '.NumericScalarExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'upperBound',
        ti: '.ScalarExprType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'minus',
        ti: '.CoverageExprPairType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'div',
        ti: '.CoverageExprPairType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'setInterpolationSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'greaterThan',
        ti: '.CoverageExprPairType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'imageCrsDomain',
        ti: '.CondenseScalarExprType.ImageCrsDomain',
        sc: '.CoverageExprPairType'
      }, {
        en: 'unaryPlus',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'setIdentifier',
        ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'lessThan',
        ti: '.CoverageExprPairType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'min',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'ln',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'notEqual',
        ti: '.CoverageExprPairType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'and',
        ti: '.CoverageExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'booleanConstant',
        ti: 'Boolean',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'lessThan',
        ti: '.CoverageExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'overlay',
        ti: '.CoverageExprPairType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'scale',
        ti: '.ScaleCoverageExprType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'booleanXor',
        ti: '.BooleanScalarExprPairType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'mult',
        ti: '.CoverageExprPairType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'stringIdentifier',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'arcsin',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 're',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'lessOrEqual',
        ti: '.CoverageExprPairType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'setCrsSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet',
        sc: '.AxisIteratorType'
      }, {
        en: 'const',
        ti: '.ConstantCoverageExprType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'const',
        ti: '.ConstantCoverageExprType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'booleanNotEqualString',
        ti: '.StringScalarExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'setCrsSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetCrsSet',
        sc: '.CoverageExprPairType'
      }, {
        en: 'mult',
        ti: '.CoverageExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'interpolationMethod',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'tanh',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'where',
        ti: '.BooleanScalarExprType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'crsSet',
        ti: '.CoverageExprElementType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'numericDiv',
        ti: '.NumericScalarExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'tanh',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'equals',
        ti: '.CoverageExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'booleanNotEqualNumeric',
        ti: '.NumericScalarExprPairType',
        sc: '.BooleanScalarExprPairType'
      }, {
        en: 'fieldSelect',
        ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'cosh',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'setIdentifier',
        ti: '.CondenseScalarExprType.InterpolationSet.SetIdentifier',
        sc: '.CoverageExprPairType'
      }, {
        en: 'min',
        ti: '.CoverageExprElementType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'div',
        ti: '.CoverageExprPairType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'ln',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'setNullSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetNullSet',
        sc: '.CoverageExprPairType'
      }, {
        en: 'interpolationMethod',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'numericMinus',
        ti: '.NumericScalarExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'greaterThan',
        ti: '.CoverageExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'numericMinus',
        ti: '.NumericScalarExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'some',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'overlay',
        ti: '.CoverageExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 're',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'scale',
        ti: '.ScaleCoverageExprType',
        sc: '.AxisIteratorType'
      }, {
        en: 'some',
        ti: '.CoverageExprElementType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'numericConstant',
        ti: 'Double',
        sc: '.CoverageExprPairType'
      }, {
        en: 'unaryPlus',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'sin',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'avg',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'sin',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'equals',
        ti: '.CoverageExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'greaterOrEqual',
        ti: '.CoverageExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'extend',
        ti: '.ExtendCoverageExprType',
        sc: '.AxisIteratorType'
      }, {
        en: 'unaryPlus',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'opPlus',
        ti: 'AnyType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'scale',
        ti: '.ScaleCoverageExprType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'stringIdentifier',
        ti: '.CoverageExprElementType',
        sc: '.StringScalarExprPairType'
      }, {
        en: 'plus',
        ti: '.CoverageExprPairType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'xor',
        ti: '.CoverageExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'exp',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'crsTransform',
        ti: '.CrsTransformCoverageExprType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'booleanEqualString',
        ti: '.StringScalarExprPairType',
        sc: '.BooleanScalarExprPairType'
      }, {
        en: 'bit',
        ti: '.CondenseScalarExprType.InterpolationSet.Bit',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'mult',
        ti: '.CoverageExprPairType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'lessOrEqual',
        ti: '.CoverageExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'div',
        ti: '.CoverageExprPairType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'numericUnaryMinus',
        ti: '.CondenseScalarExprType.NumericUnaryMinus',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'rangeConstructor',
        ti: '.RangeCoverageExprType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'booleanConstant',
        ti: 'Boolean',
        sc: '.BooleanScalarExprPairType'
      }, {
        en: 'bit',
        ti: '.CondenseScalarExprType.InterpolationSet.Bit',
        sc: '.CoverageExprPairType'
      }, {
        en: 'booleanNotEqualString',
        ti: '.StringScalarExprPairType',
        sc: '.BooleanScalarExprPairType'
      }, {
        en: 'unaryPlus',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'arctan',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'overlay',
        ti: '.CoverageExprPairType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'rangeConstructor',
        ti: '.RangeCoverageExprType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'booleanAnd',
        ti: '.BooleanScalarExprPairType',
        sc: '.BooleanScalarExprPairType'
      }, {
        en: 'upperBound',
        ti: '.ScalarExprType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'abs',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'interpolationSet',
        ti: '.CondenseScalarExprType.InterpolationSet',
        sc: '.CoverageExprPairType'
      }, {
        en: 'opMax',
        ti: 'AnyType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'abs',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'arctan',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'cos',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'greaterOrEqual',
        ti: '.CoverageExprPairType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'numericUnaryMinus',
        ti: '.CondenseScalarExprType.NumericUnaryMinus',
        sc: '.NumericScalarExprPairType'
      }, {
        en: 'exp',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'cosh',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'log',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'numericDiv',
        ti: '.NumericScalarExprPairType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'arcsin',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'arcsin',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'cast',
        ti: '.CondenseScalarExprType.InterpolationSet.Cast',
        sc: '.AxisIteratorType'
      }, {
        en: 'fieldSelect',
        ti: '.CondenseScalarExprType.InterpolationSet.FieldSelect',
        sc: '.AxisIteratorType'
      }, {
        en: 'im',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'xor',
        ti: '.CoverageExprPairType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'greaterThan',
        ti: '.CoverageExprPairType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'abs',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'setInterpolationSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet',
        sc: '.AxisIteratorType'
      }, {
        en: 'booleanLessOrEqual',
        ti: '.NumericScalarExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'im',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'cast',
        ti: '.CondenseScalarExprType.InterpolationSet.Cast',
        sc: '.CoverageExprPairType'
      }, {
        en: 'or',
        ti: '.CoverageExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'unaryPlus',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'greaterOrEqual',
        ti: '.CoverageExprPairType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'greaterOrEqual',
        ti: '.CoverageExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'abs',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'cos',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'plus',
        ti: '.CoverageExprPairType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'arcsin',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'axis',
        sc: '.AxisIteratorType'
      }, {
        en: 'opMult',
        ti: 'AnyType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'greaterThan',
        ti: '.CoverageExprPairType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'mult',
        ti: '.CoverageExprPairType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'upperBound',
        ti: '.ScalarExprType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'booleanConstant',
        ti: 'Boolean',
        sc: '.CoverageExprPairType'
      }, {
        en: 'exp',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'extend',
        ti: '.ExtendCoverageExprType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'upperBound',
        ti: '.ScalarExprType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'bit',
        ti: '.CondenseScalarExprType.InterpolationSet.Bit',
        sc: '.AxisIteratorType'
      }, {
        en: 'xor',
        ti: '.CoverageExprPairType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'numericConstant',
        ti: 'Double',
        sc: '.AxisIteratorType'
      }, {
        en: 'setInterpolationSet',
        ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationSet',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'log',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 're',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'lessThan',
        ti: '.CoverageExprPairType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'booleanLessOrEqual',
        ti: '.NumericScalarExprPairType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'stringConstant',
        sc: '.CoverageExprPairType'
      }, {
        en: 'lessOrEqual',
        ti: '.CoverageExprPairType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'unaryMinus',
        ti: '.CoverageExprElementType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'booleanLessThan',
        ti: '.NumericScalarExprPairType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 're',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'or',
        ti: '.CoverageExprPairType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'lowerBound',
        ti: '.ScalarExprType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'notEqual',
        ti: '.CoverageExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'ProcessCoveragesRequest',
        ti: '.ProcessCoveragesRequestType'
      }, {
        en: 'extend',
        ti: '.ExtendCoverageExprType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'setInterpolationDefault',
        ti: '.CondenseScalarExprType.InterpolationSet.SetInterpolationDefault',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'crsTransform',
        ti: '.CrsTransformCoverageExprType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'construct',
        ti: '.ConstructCoverageExprType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'booleanGreaterOrEqual',
        ti: '.NumericScalarExprPairType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'booleanOr',
        ti: '.BooleanScalarExprPairType',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'imageCrsDomain',
        ti: '.CondenseScalarExprType.ImageCrsDomain',
        sc: '.CondenseScalarExprType'
      }, {
        en: 'abs',
        ti: '.CoverageExprElementType',
        sc: '.AxisIteratorType'
      }, {
        en: 'unaryMinus',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'plus',
        ti: '.CoverageExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'and',
        ti: '.CoverageExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'trim',
        ti: '.TrimCoverageExprType',
        sc: '.AxisIteratorType'
      }, {
        en: 'mult',
        ti: '.CoverageExprPairType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'tan',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'plus',
        ti: '.CoverageExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'rangeConstructor',
        ti: '.RangeCoverageExprType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'lessOrEqual',
        ti: '.CoverageExprPairType',
        sc: '.AxisIteratorType'
      }, {
        en: 'arccos',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'slice',
        ti: '.SliceCoverageExprType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'nullResistance',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'sqrt',
        ti: '.CoverageExprElementType',
        sc: '.CrsTransformCoverageExprType'
      }, {
        en: 'arcsin',
        ti: '.CoverageExprElementType',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'imageCrs',
        ti: '.CoverageExprElementType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'numericMinus',
        ti: '.NumericScalarExprPairType',
        sc: '.NumericScalarExprPairType'
      }, {
        en: 'extend',
        ti: '.ExtendCoverageExprType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'coverage',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'trim',
        ti: '.TrimCoverageExprType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'scale',
        ti: '.ScaleCoverageExprType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'booleanOr',
        ti: '.BooleanScalarExprPairType',
        sc: '.CoverageExprPairType'
      }, {
        en: 'overlay',
        ti: '.CoverageExprPairType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'construct',
        ti: '.ConstructCoverageExprType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'scale',
        ti: '.ScaleCoverageExprType',
        sc: '.TrimCoverageExprType'
      }, {
        en: 'numericUnaryMinus',
        ti: '.CondenseScalarExprType.NumericUnaryMinus',
        sc: '.AxisIteratorType'
      }, {
        en: 'ln',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'name',
        sc: '.ScaleCoverageExprType'
      }, {
        en: 'tanh',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'cos',
        ti: '.CoverageExprElementType',
        sc: '.ExtendCoverageExprType'
      }, {
        en: 'greaterOrEqual',
        ti: '.CoverageExprPairType',
        sc: '.ExtendCoverageExprType'
      }]
  };
  return {
    WCPS_1_0: WCPS_1_0
  };
};
if (typeof define === 'function' && define.amd) {
  define([], WCPS_1_0_Module_Factory);
}
else {
  var WCPS_1_0_Module = WCPS_1_0_Module_Factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports.WCPS_1_0 = WCPS_1_0_Module.WCPS_1_0;
  }
  else {
    var WCPS_1_0 = WCPS_1_0_Module.WCPS_1_0;
  }
}